import { render } from "./ElevatorItem.vue?vue&type=template&id=2203b77d&scoped=true"
import script from "./ElevatorItem.vue?vue&type=script&lang=js"
export * from "./ElevatorItem.vue?vue&type=script&lang=js"

import "./ElevatorItem.vue?vue&type=style&index=0&id=2203b77d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Admin\\Desktop\\Тестовое TrueConf\\true_conf\\elevator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2203b77d"]])

export default __exports__